export default __webpack_public_path__ + "static/media/pic27.78fe2168.png";